<template>
    <div :class="classes">
        <kl-ol-map
            v-bind="$attrs"
            :zoom="zoom"
            :center="center"
            :ref="refMap"
            :id="olMapId"
            tabindex="0"
            :style="mapStyle"
            mod-boxed
            :map-disable-mouse-wheel-zoom="modDisableScrollZoom"
        >
            <template v-slot:default>
                <kl-ol-map-loader v-if="isLoading" mod-blocking>
                    {{ loadingMessage }}
                </kl-ol-map-loader>
                <slot></slot>
            </template>
            <template v-slot:tile-navigation>
                <vl-tile-navigation v-if="!!$slots['tile-navigation']">
                    <slot name="tile-navigation"></slot>
                </vl-tile-navigation>
            </template>
            <template v-slot:sidebar>
                <slot name="sidebar"></slot>
            </template>
            <template v-slot:search>
                <slot name="search"></slot>
            </template>
            <template v-slot:base-layer>
                <ippro-map-layer-toggle
                    ref="layerToggle"
                    :layers="layers"
                    @switch-layer="setLayer"
                />
                <slot name="base-layer"></slot>
            </template>
            <template v-slot:action-tools>
                <slot name="action-tools"></slot>
            </template>
            <template v-slot:view-tools>
                <kl-ol-map-tools-bar mod-vertical v-vl-print:no>
                    <kl-ol-map-tools-action-group mod-vertical v-if="modToggleFullscreen">
                        <ippro-map-fullscreen @change="toggleFullscreen" :init-active="fullscreen"/>
                    </kl-ol-map-tools-action-group>
                    <slot name="view-tools"></slot>
                    <kl-ol-map-tools-action-group mod-vertical v-if="modZoom">
                        <kl-ol-map-tools-action
                            @click.prevent="zoomIn"
                            ref="zoomInButton"
                            icon="plus"
                            text="Zoom in"
                            v-vl-tooltip.left.hide-immediately="'Zoom&nbsp;in'"
                        />
                        <kl-ol-map-tools-action
                            @click.prevent="zoomOut"
                            ref="zoomOutButton"
                            icon="minus"
                            text="Zoom uit"
                            v-vl-tooltip.left.hide-immediately="'Zoom&nbsp;uit'"
                        />
                    </kl-ol-map-tools-action-group>
                </kl-ol-map-tools-bar>
            </template>
            <template v-slot:info>
                <kl-ol-map-info>
                    <kl-ol-map-info-item :id="mapScaleId" label=""/>
                    <kl-ol-map-info-item :label="projectionLabel"/>
                    <kl-ol-map-info-item

                        ref="mapMousePosition"
                        :id="mapMousePositionId"
                        label=""
                    />
                    <slot name="map-info"></slot>
                </kl-ol-map-info>
            </template>
        </kl-ol-map>
        <div class="ippro-map__placeholder"></div>
    </div>
</template>

<script lang="ts" src="./vl-ippro-map.ts"></script>

<style lang="scss">
@import "./vl-ippro-map.scss";
</style>
